module.exports = "./img/desktop_logo.dba88f6.png";